import { render, staticRenderFns } from "./GroupMultibarChart.vue?vue&type=template&id=787bf4a4&scoped=true&"
import script from "./GroupMultibarChart.vue?vue&type=script&lang=js&"
export * from "./GroupMultibarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787bf4a4",
  null
  
)

export default component.exports